import React, { createContext, useContext } from 'react';
import type { ILegalDependencyData } from '../Interfaces/ILegalDependency';

interface ILegalDependencyContext {
  legalDependencyData: ILegalDependencyData;
  setLegalDependencyData: React.Dispatch<
    React.SetStateAction<ILegalDependencyData>
  >;
}

const LegalDependencyContext = createContext<ILegalDependencyContext | null>(
  null
);

export const LegalDependencyProvider: React.FC<{
  value: ILegalDependencyContext;
  children: React.ReactNode;
}> = ({ value, children }) => (
  <LegalDependencyContext.Provider value={value}>
    {children}
  </LegalDependencyContext.Provider>
);

export const useLegalDependency = (): ILegalDependencyContext => {
  const ctx = useContext(LegalDependencyContext);
  if (!ctx)
    throw new Error(
      'useLegalDependency must be used within LegalDependencyProvider'
    );
  return ctx;
};
